import store from "../store"; 

export const redirect_to_asset = (router, ...parameters) => {
  router.push(`/${parameters.join("/")}`);
};

export const first_letter_uppercase = (text) => {
  return text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : null;
};